import React from 'react';
import { Button, Row, Col, Modal } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from 'react-redux';
import { remove } from 'stores/financialEntries/financialEntryActions';

const Icon = ({ checked }) => {
  return (
    <FontAwesomeIcon
      icon="redo-alt"
      className="gx-mr-2"
      color={checked ? '#40c057' : '#495057'}
    />
  );
};

const FinancialEntryToolbarEdit = ({
  readOnly,
  backButtonText,
  onBackClick,
  okButtonText,
  onOkClick,
  saving,
  record
}) => {
  const dispatch = useDispatch();

  const { deleting } = useSelector(
    (c) => c.resources['financial-entries'] ?? {}
  );

  const handleDelete = () => {
    Modal.confirm({
      title: 'Deseja excluir ?',
      okText: 'Excluir',
      width: 600,
      onOk: () => {
        dispatch(remove(record.id));
      }
    });
  };

  return (
    <Row className="no-margin no-padding" justify="end">
      <Col>
        {readOnly ? (
          <Button onClick={onBackClick} style={{ marginRight: 8 }}>
            {backButtonText}
          </Button>
        ) : (
          <>
            {record?.id && (
              <Button
                className="gx-text-error"
                onClick={handleDelete}
                loading={deleting}
              >
                Excluir
              </Button>
            )}
            <Button
              onClick={onBackClick}
              style={{ marginRight: 8 }}
              disabled={deleting}
            >
              {backButtonText}
            </Button>
            <Button
              onClick={onOkClick}
              type="primary"
              loading={saving}
              disabled={deleting}
            >
              {okButtonText}
            </Button>
          </>
        )}
      </Col>
    </Row>
  );
};

export default FinancialEntryToolbarEdit;
